import React from 'react';
import { ViewModifierState } from './viewModifierState/ViewModifierState';
import { ViewForm } from './components/ViewForm';
import { ModalWindows } from './components/ModalWindows';

export const ViewModifierPageV2: React.FC = () => {
	return (
		<ViewModifierState>
			<ViewForm />
			<ModalWindows />
		</ViewModifierState>
	);
};
